import React from 'react';
// import { Payments } from './FooterPayments';
import { Usp } from './FooterUsp';
import { Menus } from './FooterMenus';
import { TopImage } from './FooterTopImage';
import { Payments } from './FooterPayments';

const Footer = (props: FooterProps) => {
  return (
    <footer className="bg-gray-800">
      <TopImage {...props.top} />
      <Usp {...props.usp} />
      <Menus
        banner={props.banner}
        socials={props.socials}
        firstMenu={props.sectionList[0]}
        secondMenu={props.sectionList[1]}
      />
      <Payments {...props.paymentAndDelivery} />
    </footer>
  );
};

export default Footer;
